import "./ball-variants.css"
import "./tube-variants.css"

type Theme = "dark" | "light"
const THEMES: readonly Theme[] = ["light", "dark"]

interface Ball3DVariant {
  className: string
  id: string
  name: string
}

const VARIANTS: readonly Ball3DVariant[] = [
  { className: "sa-ball--3d-1", id: "glass", name: "Glass" },
  { className: "sa-ball--3d-2", id: "chrome", name: "Chrome" },
  { className: "sa-ball--3d-3", id: "neon", name: "Neon" },
  { className: "sa-ball--3d-4", id: "enamel", name: "Enamel" },
  { className: "sa-ball--3d-5", id: "velvet", name: "Velvet" },
  { className: "sa-ball--3d-6", id: "holographic", name: "Holographic" },
  { className: "sa-ball--3d-7", id: "aurora", name: "Aurora" },
  { className: "sa-ball--3d-8", id: "solar", name: "Solar Flare" },
  { className: "sa-ball--3d-9", id: "ocean", name: "Ocean Prism" },
  { className: "sa-ball--3d-10", id: "vapor", name: "Vapor Dream" },
  { className: "sa-ball--3d-11", id: "galaxy", name: "Galaxy" },
]

export function Ball3DVariants() {
  return (
    <section aria-label="3D ball variants" className="bv">
      <h2 className="text-xl font-bold">
        Ball variants — {VARIANTS.length} 3D treatments × {THEMES.length}{" "}
        backgrounds
      </h2>
      <p className="">
        Each ball uses the same solid hue; the 3D feel comes entirely from the
        specular highlight and shadow treatment.
      </p>
      <div className="bv-grid">
        {VARIANTS.flatMap(({ className, id, name })=>
          THEMES.map(theme=> (
            <figure className="tv-card" key={`${id}-${theme}`}>
              <div
                className={`
                  tv-stage
                  tv-stage--${theme}
                `}
              >
                <span
                  aria-hidden="true"
                  className={`
                    sa-ball
                    ${className}
                    bv-size--sm
                    bv-cva--coral
                  `}
                />
              </div>
              <figcaption className="bv-caption">
                <strong>
                  {name} · {theme}
                </strong>
              </figcaption>
            </figure>
          )),
        )}
      </div>
    </section>
  )
}
